export default __webpack_public_path__ + "static/media/video-placeholder.a42e00cf.jpeg";